/**
 * Single source of truth for all notification kinds.
 * Canonical values are snake_case everywhere: backend constants, DB `Kind`
 * column, push `data.kind`, shared-types, and mobile comparisons.
 */
export const NOTIFICATION_KINDS = {
    MEMBERSHIP_REQUEST_CREATED: "membership_request_created",
    MEMBERSHIP_REQUEST_APPROVED: "membership_request_approved",
    MEMBERSHIP_REQUEST_REJECTED: "membership_request_rejected",
    MEMBERSHIP_REQUEST_CANCELLED: "membership_request_cancelled",
    RECURRING_ENROLLMENT_ENDED: "recurring_enrollment_ended",
    CLASS_TRAINER_SIGNUP: "class_trainer_signup",
    CLASS_TRAINER_BOOKING_CANCELLED: "class_trainer_booking_cancelled",
    CLASS_MEMBER_BOOKING_CANCELLED: "class_member_booking_cancelled",
    CLASS_OCCURRENCE_UPDATED: "class_occurrence_updated",
    CLASS_OCCURRENCE_CANCELLED: "class_occurrence_cancelled",
    CLASS_SERIES_CANCELLED_MEMBER: "class_series_cancelled_member",
    CLASS_SERIES_CANCELLED_TRAINER: "class_series_cancelled_trainer",
    PT_REQUEST_CREATED: "pt_request_created",
    PT_REQUEST_APPROVED: "pt_request_approved",
    PT_REQUEST_DECLINED: "pt_request_declined",
    PT_REQUEST_CANCELLED: "pt_request_cancelled",
    PT_APPOINTMENT_SCHEDULED: "pt_appointment_scheduled",
};
/** Sorted list of all canonical kind values for parity assertions across stacks. */
export const ALL_NOTIFICATION_KIND_VALUES = Object.values(NOTIFICATION_KINDS).sort();
/** @deprecated Use NOTIFICATION_KINDS instead. */
export const NOTIFICATION_INBOX_BACKEND_KINDS = NOTIFICATION_KINDS;
